/**
 * Local mapping shape for the Kanban visualization. Lives here (not in
 * `@deckspace/types`) because Kanban is its own ComponentNode type — dispatch
 * happens via the node `type` field, not via a `kind` discriminator on mapping.
 */
export interface KanbanMapping {
  card: string;
  column: string;
  subtitle?: string;
}

/**
 * Result shape consumed by the Kanban visualization. The component does the
 * actual grouping internally; this prep just normalizes the mapping fields
 * into the shape the component reads.
 */
export interface KanbanResult {
  rows: Record<string, unknown>[];
  cardField: string;
  columnField: string;
  subtitleField?: string;
}

export function prepKanbanData(
  rows: Record<string, unknown>[],
  mapping: KanbanMapping
): KanbanResult {
  return {
    rows,
    cardField: mapping.card,
    columnField: mapping.column,
    subtitleField: mapping.subtitle,
  };
}
